import { IState } from '../../store';
import { IFactoid } from '../../types/factoid';

export const selectFactoids = (state: IState): IFactoid[] => state.offerData.factoids;
